import { YUP_VALIDATIONS } from '@plug/helpers/yup-helpers';
import * as Yup from 'yup';

export const OrganizationRegisterPersonalDataSchema = Yup.object().shape({
  name: YUP_VALIDATIONS.name,
  birthday: YUP_VALIDATIONS.birthday,
  email: YUP_VALIDATIONS.email,
  role: YUP_VALIDATIONS.role,
  phone: YUP_VALIDATIONS.phone,
  gender: YUP_VALIDATIONS.gender,
});
